import { SiafLiteApiRepository } from "../../external";
import store from "../../config/store";

class PainelFiscalService {
  constructor() {
    this.urlBase = "faturamento/painel-fiscal";
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getIndicadores(body) {
    return new SiafLiteApiRepository(`${this.urlBaseCompleta}/indicadores`).post(body);
  }

  getProdutosAnaliseIa(body) {
    return new SiafLiteApiRepository(`${this.urlBaseCompleta}/produtos-ia`).post(body);
  }

  analisarComIa(body) {
    return new SiafLiteApiRepository(`${this.urlBaseCompleta}/analisar-ia`).post(body);
  }
}

export default PainelFiscalService;
